
export interface Configuration {
    langs:Array<string>  
    editorDefaultConfig:any  
    email:{
    sendinblueApiKey: string
    senderEmail: string
    senderName: string
    testMode: boolean
    testEmail: string
    bccEmails: string
    }        
    
}


export const getDefaultConfiguration = () => {
    return {        
        langs:["fr","en"],        
        //https://ckeditor.com/latest/samples/toolbarconfigurator/index.html#basic
        editorDefaultConfig : {
            language: 'fr',
            toolbarGroups : [
              { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
              { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
              { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
              { name: 'forms', groups: [ 'forms' ] },
              { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
              { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
              { name: 'links', groups: [ 'links' ] },
              { name: 'insert', groups: [ 'insert' ] },
              { name: 'styles', groups: [ 'styles' ] },
              { name: 'colors', groups: [ 'colors' ] },
              { name: 'tools', groups: [ 'tools' ] },
              { name: 'others', groups: [ 'others' ] },
              { name: 'about', groups: [ 'about' ] }
            ],
            removeButtons:'Save,NewPage,Preview,Print,Templates,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Strike,Subscript,Superscript,Underline,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,HorizontalRule,Smiley,Iframe,PageBreak,Font,ShowBlocks,About'
        },
        email:{
          sendinblueApiKey: "",
          senderEmail: "noreply@centralweb.fr",
          senderName: "Central Web",
          testMode: true,
          testEmail: "slarrasoain@centralweb.fr",
          bccEmails: "slarrasoain@centralweb.fr"
        }
    } as Configuration
}